<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  [customFormControls]="{
    hospitalID: hospitalID,
  }"
  (search)="onSearch($event)"
>
  <ng-template
    #hospitalID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-hospital-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="hospitalID"
      />
    </ng-container>
  </ng-template>
  <ng-container actions>
    <p-button
      size="small"
      label="Νέα Κλινική"
      icon="pi pi-plus"
      [disabled]="isLoading()"
      (onClick)="onCreateClinic()"
    />
  </ng-container>
</eo-search-page>

<app-clinic-form-dialog #clinicFormDialog (success)="onClinicFormSuccess()" />

<p-confirmPopup key="deleteClinicPopup" [style]="{ width: '700px' }">
</p-confirmPopup>
